import React, { useState, useEffect } from 'react';
import Sale01 from '../components/sale/Sale01';
import { landingPageApi } from '../api/landing-page-api';

const DEFAULT_CONTACT = {
    emails: ['support@tradiora.id', 'hello@tradiora.id'],
    phones: ['+62 896-2048-5769'],
    address: 'Jl. Jend. Gatot Subroto No.67, Purwokerto, Banyumas, Jawa Tengah 53116',
    social_handle: '@tradiora_official',
};

function Contact() {
    const [contactInfo, setContactInfo] = useState(DEFAULT_CONTACT);
    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.subject || !form.message) {
            setError('Harap isi semua field');
            return;
        }
        setSubmitting(true);
        setError('');
        try {
            await landingPageApi.sendContactInquiry(form);
            setSubmitted(true);
            setForm({ name: '', email: '', subject: '', message: '' });
        } catch (err) {
            setError(err.message || 'Gagal mengirim pesan. Silakan coba lagi.');
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        landingPageApi.getContactInfo().then(data => {
            if (data) {
                setContactInfo({
                    emails: data.emails || DEFAULT_CONTACT.emails,
                    phones: data.phones || DEFAULT_CONTACT.phones,
                    address: data.address || DEFAULT_CONTACT.address,
                    social_handle: data.social_handle || DEFAULT_CONTACT.social_handle,
                });
            }
        });
    }, []);

    return (
        <div>
            <section style={{
                padding: '100px 0 80px',
                background: 'linear-gradient(135deg, #0a1628 0%, #0d1f3c 30%, #0C8F86 100%)',
                position: 'relative',
                overflow: 'hidden',
            }}>
                <div style={{
                    position: 'absolute', top: '-20%', right: '-10%', width: 400, height: 400,
                    borderRadius: '50%', background: 'rgba(12,143,134,0.15)', filter: 'blur(60px)',
                }} />
                <div style={{
                    position: 'absolute', bottom: '-10%', left: '-5%', width: 300, height: 300,
                    borderRadius: '50%', background: 'rgba(12,143,134,0.1)', filter: 'blur(50px)',
                }} />
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="block-text center">
                                <h3 className="heading" style={{ color: '#fff' }}>Hubungi Kami</h3>
                                <p className="fs-20" style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 600, margin: '0 auto' }}>
                                    Punya pertanyaan atau butuh bantuan? Tim Tradiora siap membantu Anda
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section style={{ padding: '80px 0' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-md-12" style={{ marginBottom: 40 }}>
                            <h4 style={{ marginBottom: 24, fontSize: 22 }}>Informasi Kontak</h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                                <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                                    <div style={{
                                        width: 48, height: 48, borderRadius: 12,
                                        background: 'var(--primary-light)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, flexShrink: 0,
                                    }}>📧</div>
                                    <div>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Email</div>
                                        {contactInfo.emails.map((email, i) => (
                                            <div key={`email-${i}`} style={{ color: 'var(--text)', fontSize: 14 }}>{email}</div>
                                        ))}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                                    <div style={{
                                        width: 48, height: 48, borderRadius: 12,
                                        background: 'var(--primary-light)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, flexShrink: 0,
                                    }}>📞</div>
                                    <div>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Telepon</div>
                                        {contactInfo.phones.map((phone, i) => (
                                            <div key={`phone-${i}`} style={{ color: 'var(--text)', fontSize: 14 }}>{phone}</div>
                                        ))}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                                    <div style={{
                                        width: 48, height: 48, borderRadius: 12,
                                        background: 'var(--primary-light)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, flexShrink: 0,
                                    }}>📍</div>
                                    <div>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Alamat</div>
                                        <div style={{ color: 'var(--text)', fontSize: 14 }}>
                                            {contactInfo.address}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                                    <div style={{
                                        width: 48, height: 48, borderRadius: 12,
                                        background: 'var(--primary-light)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, flexShrink: 0,
                                    }}>💬</div>
                                    <div>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Media Sosial</div>
                                        <div style={{ color: 'var(--text)', fontSize: 14 }}>
                                            {contactInfo.social_handle}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 offset-xl-1 col-md-12">
                            <h4 style={{ marginBottom: 24, fontSize: 22 }}>{submitted ? 'Pesan Terkirim' : 'Kirim Pesan'}</h4>
                            {submitted ? (
                                <div style={{
                                    padding: 40, textAlign: 'center', borderRadius: 16,
                                    background: 'var(--primary-light)', border: '1px solid var(--primary)',
                                }}>
                                    <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                                    <h5 style={{ marginBottom: 8 }}>Terima Kasih!</h5>
                                    <p style={{ color: 'var(--text)', marginBottom: 20 }}>
                                        Pesan Anda telah kami terima. Tim Tradiora akan menghubungi Anda segera.
                                    </p>
                                    <button className="btn-action" onClick={() => setSubmitted(false)}>
                                        Kirim Pesan Lagi
                                    </button>
                                </div>
                            ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6" style={{ marginBottom: 20 }}>
                                        <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 14 }}>Nama Lengkap</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={form.name}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Masukkan nama Anda"
                                            style={{
                                                width: '100%', padding: '14px 18px', borderRadius: 12,
                                                border: '1px solid var(--line)', background: 'var(--bg)',
                                                color: 'var(--onsurface)', fontSize: 14, outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6" style={{ marginBottom: 20 }}>
                                        <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 14 }}>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Masukkan email Anda"
                                            style={{
                                                width: '100%', padding: '14px 18px', borderRadius: 12,
                                                border: '1px solid var(--line)', background: 'var(--bg)',
                                                color: 'var(--onsurface)', fontSize: 14, outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div style={{ marginBottom: 20 }}>
                                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 14 }}>Subjek</label>
                                    <select name="subject" value={form.subject} onChange={handleChange} className="form-control" style={{
                                        width: '100%', padding: '14px 18px', borderRadius: 12,
                                        border: '1px solid var(--line)', background: 'var(--bg)',
                                        color: 'var(--onsurface)', fontSize: 14, outline: 'none',
                                    }}>
                                        <option value="">Pilih subjek</option>
                                        <option value="Informasi Produk">Informasi Produk</option>
                                        <option value="Bantuan Teknis">Bantuan Teknis</option>
                                        <option value="Kerjasama">Kerjasama</option>
                                        <option value="Lainnya">Lainnya</option>
                                    </select>
                                </div>
                                <div style={{ marginBottom: 24 }}>
                                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 14 }}>Pesan</label>
                                    <textarea
                                        name="message"
                                        value={form.message}
                                        onChange={handleChange}
                                        cols="30"
                                        rows="5"
                                        className="form-control"
                                        placeholder="Tulis pesan Anda..."
                                        style={{
                                            width: '100%', padding: '14px 18px', borderRadius: 12,
                                            border: '1px solid var(--line)', background: 'var(--bg)',
                                            color: 'var(--onsurface)', fontSize: 14, outline: 'none',
                                            resize: 'vertical', fontFamily: 'inherit',
                                        }}
                                    ></textarea>
                                </div>
                                {error && (
                                    <div style={{ color: '#ef4444', marginBottom: 16, fontSize: 14 }}>{error}</div>
                                )}
                                <button type="submit" className="btn-action" style={{ padding: '14px 40px', fontSize: 15 }} disabled={submitting}>
                                    {submitting ? 'Mengirim...' : 'Kirim Pesan'}
                                </button>
                            </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <Sale01 />
        </div>
    );
}

export default Contact;